import { render, staticRenderFns } from "./bindFiling.vue?vue&type=template&id=44f02ac4&scoped=true&"
import script from "./bindFiling.vue?vue&type=script&lang=js&"
export * from "./bindFiling.vue?vue&type=script&lang=js&"
import style0 from "./bindFiling.vue?vue&type=style&index=0&id=44f02ac4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f02ac4",
  null
  
)

export default component.exports